import React, { memo } from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import { Image, Link } from 'pcln-design-system'

const StyledImage = styled(Image)`
  height: 100%;
`
StyledImage.displayName = 'StyledImage'

const LogoLink = styled(Link)`
  display: contents;
  z-index: 10;
  height: 100%;
`
LogoLink.displayName = 'LogoLink'

function NavLogo({ title, path, href, target, color, leftPadding, rightPadding }) {
  const logo = (
    <StyledImage title={title} src={path} data-testid='nav-logo' pl={leftPadding} pr={rightPadding} />
  )

  return href ? (
    <LogoLink href={href} color={color} target={target} rel='noopener' data-testid='nav-logo'>
      {logo}
    </LogoLink>
  ) : (
    logo
  )
}

NavLogo.displayName = 'NavLogo'

NavLogo.propTypes = {
  title: PropTypes.string,
  path: PropTypes.string,
  href: PropTypes.string,
  target: PropTypes.string,
  color: PropTypes.string,
  leftPadding: PropTypes.number,
  rightPadding: PropTypes.number,
}

NavLogo.defaultProps = {
  leftPadding: 0,
  rightPadding: 0,
}

export default memo(NavLogo)
